export default "__VITE_ASSET__BlOXiGSK__"